/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { mutatorAction } from "satcheljs";
import { appViewState } from "..";

/**
 * Sets the cross location select teams modal state
 * @param isOpen Whether the modal is open
 */
export default mutatorAction(
    "SET_CROSS_LOCATION_SELECT_TEAMS_MODAL_STATE",
    function setCrossLocationSelectTeamsModalState(isOpen: boolean) {
        appViewState().crossLocationSelectTeamsModalViewState.isOpen = isOpen;
    }
);
